import React, { Component } from "react"
import Modal from "react-modal"
import CustomerInvoicesDisburseModalUI from "./CustomerInvoicesDisburseModalUI"
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"

class CustomerInvoicesDisburseModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      //
      submitted: false,
      //
      disbursedDate: '',
      disbursedDateError: null
    }
  }

  render() {
    return (
      <CustomerInvoicesDisburseModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        //
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        //
        onSubmit={this.onSubmit}
        onCancelCreate={this.onCancelCreate}
        //
        disbursedDate={this.state.disbursedDate}
        onDisbursedDateChange={(selectedDateISO) => { this.setState({ disbursedDate: selectedDateISO }) }}
        disbursedDateError={this.state.disbursedDateError}
        setDisbursedDateError={(error) => { this.setState({ disbursedDateError: error }) }}
      />
    )
  }

  onCancelCreate = () => {
    this.setState({
      submitted: false,
      errorList: null
    })
    this.props.onCancelCreate()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/customerInvoices/${this.props.selectedCustomerInvoiceId}/disbursements`,
      this.onSubmitCallback, {
      disbursedDate: this.state.disbursedDate,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelCreate()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default CustomerInvoicesDisburseModalSF;